
import React, { useEffect, useState } from 'react';
import Icon from '../../components/AppIcon';
import ResponsiveTopNavigation from '../../components/navigation/ResponsiveTopNavigation';
import CouponsSection from 'pages/restaurant-home-page/components/CouponsSection';
import CartCopouns from './components/CartCopounes';
import { useNavigate } from 'react-router-dom';
import { base_url } from 'Backend/api';
import toast from 'react-hot-toast';
import { Helmet } from 'react-helmet';
import Footer from 'components/Footer';
import ResponsiveTopNavigation2 from 'components/navigation/ResponsiveTopNavigation2';
import AppSpinner from 'components/ui/AppSpinner';
import Lottie from "lottie-react";
import cartDeleteAnimation from "../../../public/assets/lottie/CartDelete.json";

const CartDeleteConfirmDialog = ({
  open,
  title,
  description,
  confirmLabel,
  onCancel,
  onConfirm,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/35 px-3 font-[cairo]">
      <div className="relative w-full max-w-[360px] rounded-[8px] bg-white p-6 pt-4 shadow-[0_12px_30px_rgba(0,0,0,0.18)] md:p-4 md:pt-9">
        <button
          type="button"
          onClick={onCancel}
          className="absolute right-3.5 top-3.5 text-[#1F2937] transition hover:opacity-75"
          aria-label="إغلاق"
        >
          <Icon name="X" size={20} />
        </button>

        <div className="mx-auto mb-2.5 flex h-[106px] w-[106px] items-center justify-center rounded-full ">
          <Lottie
            animationData={cartDeleteAnimation}
            loop={true}
            className="h-[120px] w-[120px]"
          />
        </div>

        <h3 className="font-[cairo] text-center text-[20px] font-bold leading-tight text-[#1F2937] md:text-[22px]">
          {title}
        </h3>
        <p className="mt-1 font-[cairo] mb-2 text-center text-[13px] font-medium leading-tight text-[#8B8B8B] md:text-[14px]">
          {description}
        </p>

        <div className="mt-4 grid grid-cols-2 gap-2">
         
          <button
            type="button"
            onClick={onConfirm}
            className="h-[40px] rounded-[8px] bg-[#F93209] text-[14px] font-medium text-white transition hover:bg-[#e82f05]"
          >
            {confirmLabel}
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="h-[40px] rounded-[8px] border border-[#F93209] text-[14px] font-medium text-[#F93209] transition hover:bg-[#FFF3EF]"
          >
            إلغاء
          </button>
        </div>
      </div>
    </div>
  );
};

const CartPage = () => {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState({
    visible: false,
    storeId: null,
    storeType: null,
    storeName: ""
  });
  const [confirmDeleteItem, setConfirmDeleteItem] = useState({
    visible: false,
    cartItemId: null,
    itemName: "",
  });
  const [confirmDeleteCart, setConfirmDeleteCart] = useState(false);
  const [addingSuggestedKey, setAddingSuggestedKey] = useState(null);

  const resolveStorageImage = (rawPath) => {
    if (!rawPath) return "/assets/images/logo.jpeg";
    const normalized = String(rawPath).replace(/^\/+/, "");
    if (/^https?:\/\//i.test(normalized)) return normalized;
    return `${String(base_url).replace(/\/$/, "")}/storage/app/public/${normalized}`;
  };

  const fetchCartAgain = async () => {
    try {
      setIsUpdating(true);
      const token = localStorage.getItem("token");
      const response = await fetch(`${base_url}/api/cart`, {
        method: "GET",
        headers: { "Authorization": `Bearer ${token}`, "Accept": "application/json" }
      });
      const data = await response.json();
      if (data.status) {
        const stores = data.data.stores;
        const summaryData = data.data.summary;
        const transformedStores = stores.map((store) => ({
          id: store.store_id,
          restaurantId: store.store_id,
          restaurantName: store.store_name,
          storeLogo: resolveStorageImage(
            store.store_logo ||
            store.logo ||
            store.icon ||
            store.image ||
            store.cover_image ||
            store?.media?.logo ||
            store?.media?.main_image ||
            store?.media?.cover_image
          ),
          storeType: store.store_type,
          storeSlug: store.store_slug,
          isExpanded: true,
          minOrderPrice: Number(store.min_order_price || 0),
          minOrderMet: Boolean(store.min_order_met),
          minOrderRemaining: Number(store.min_order_remaining || 0),
          suggestedItems: Array.isArray(store.suggested_items) ? store.suggested_items : [],
          items: store.items.map((item) => ({
            id: item.id,
            quantity: item.quantity,
            price: Number(item.actual_price),
            totalPrice: Number(item.total_price),
            name: item.dish ? item.dish.name : item.product ? item.product.name : "",
            options: [
              ...item.removed_ingredients.map(r => `بدون ${r.ingredient_name}`),
              ...item.addons.map(a => `${a.addon_name} ×${a.quantity}`),
              ...item.drinks.map(d => `${d.drink_name} ×${d.quantity}`)
            ].join(" ، "),
            image: item.dish?.image || item.product?.image || null
          }))
        }));
        setCartItems(transformedStores);
        setSummary(summaryData);
      }
    } catch (err) {
      console.error("خطأ في جلب السلة", err);
    } finally {
      setIsUpdating(false);
    }
  };

  useEffect(() => { fetchCartAgain(); }, []);

  const toggleRestaurantExpand = (restaurantId) => {
    setCartItems(cartItems?.map(r => r.restaurantId === restaurantId ? { ...r, isExpanded: !r.isExpanded } : r));
  };

  const handleStoreNavigate = (store) => {
    if (!store?.storeSlug) return;
    if (store.storeType === "market") {
      navigate(`/market/${store.storeSlug}`);
      return;
    }
    navigate(`/restaurant/${store.storeSlug}`);
  };

  const updateQuantity = async (restaurantId, itemId, delta) => {
    try {
      const token = localStorage.getItem("token");
      const restaurant = cartItems.find(r => r.restaurantId === restaurantId);
      const item = restaurant.items.find(i => i.id === itemId);
      const newQuantity = Math.max(1, item.quantity + delta);
      setIsUpdating(true);
      const response = await fetch(`${base_url}/api/cart/items/${itemId}`, {
        method: "PATCH",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ quantity: newQuantity })
      });
      const data = await response.json();
      if (data.status) await fetchCartAgain();
    } catch (error) { console.error("خطأ في تحديث الكمية", error); }
    finally { setIsUpdating(false); }
  };

  const handleDecreaseOrDelete = (restaurantId, item) => {
    if (!item) return;
    if (item.quantity <= 1) {
      openDeleteItemModal(item.id, item.name);
      return;
    }
    updateQuantity(restaurantId, item.id, -1);
  };

  const deleteItem = (restaurantId, itemId) => {
    setCartItems(cartItems?.map(r => {
      if (r.restaurantId === restaurantId) {
        const updatedItems = r.items.filter(i => i.id !== itemId);
        return { ...r, items: updatedItems };
      }
      return r;
    }).filter(r => r.items.length > 0));
  };


  const calculateRestaurantSubtotal = (restaurant) => restaurant.items.reduce((sum, item) => sum + item.totalPrice, 0);

  const subtotal = summary?.subtotal || 0;
  const deliveryFee = summary?.delivery_fee || 0;
  const totalDiscount = summary?.discount || 0;
  const total = summary?.total || 0;

  const openDeleteModal = (storeId, storeType, storeName) => {
    setConfirmDelete({ visible: true, storeId, storeType, storeName });
  };

  const closeDeleteModal = () => {
    setConfirmDelete({ visible: false, storeId: null, storeType: null, storeName: "" });
  };

  const deleteRestaurant = async () => {
    const { storeId, storeType } = confirmDelete;
    try {
      setIsUpdating(true);
      const token = localStorage.getItem("token");
      const response = await fetch(`${base_url}/api/cart/stores/${storeType}/${storeId}`, {
        method: "DELETE",
        headers: { "Authorization": `Bearer ${token}`, "Accept": "application/json" }
      });
      const data = await response.json();
      if (data.status) {
        toast.success("تم الحذف بنجاح")
        await fetchCartAgain();
      } else {
        toast.error("حدث خطأ أثناء الحذف");
      }
    } catch (error) {
      console.error("خطأ في الحذف", error);
      toast.error("حدث خطأ أثناء الحذف");
    } finally {
      setIsUpdating(false);
      closeDeleteModal();
    }
  };

  const openDeleteItemModal = (cartItemId, itemName) => {
    setConfirmDeleteItem({ visible: true, cartItemId, itemName });
  };

  const closeDeleteItemModal = () => {
    setConfirmDeleteItem({ visible: false, cartItemId: null, itemName: "" });
  };

  const deleteCartItem = async () => {
    const { cartItemId } = confirmDeleteItem;
    try {
      setIsUpdating(true);
      const token = localStorage.getItem("token");
      const response = await fetch(`${base_url}/api/cart/items/${cartItemId}`, {
        method: "DELETE",
        headers: { "Authorization": `Bearer ${token}`, "Accept": "application/json" }
      });
      const data = await response.json();
      if (data.status) {
        await fetchCartAgain();
        toast.success("تم الحذف بنجاح");
      } else {
        toast.error("حدث خطأ أثناء حذف العنصر");
      }
    } catch (error) {
      console.error("خطأ في حذف العنصر", error);
      toast.error("حدث خطأ أثناء حذف العنصر");
    } finally {
      setIsUpdating(false);
      closeDeleteItemModal();
    }
  };

  const openDeleteCartModal = () => setConfirmDeleteCart(true);
  const closeDeleteCartModal = () => setConfirmDeleteCart(false);

  const addSuggestedItemToCart = async (store, suggestedItem) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("يجب تسجيل الدخول أولاً");
        return;
      }
      const itemSlug = suggestedItem?.slug;
      if (!itemSlug || !store?.storeSlug) {
        toast.error("تعذر إضافة المنتج المقترح");
        return;
      }
      const key = `${store.storeType}_${store.restaurantId}_${suggestedItem.id}`;
      setAddingSuggestedKey(key);
      const payload =
        store.storeType === "market"
          ? {
              store_type: "market",
              market_slug: store.storeSlug,
              product_slug: itemSlug,
              quantity: 1,
            }
          : {
              store_type: "restaurant",
              restaurant_slug: store.storeSlug,
              dish_slug: itemSlug,
              quantity: 1,
            };

      const response = await fetch(`${base_url}/api/cart/items`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (response.ok && data?.status) {
        toast.success("تمت الإضافة إلى السلة");
        await fetchCartAgain();
      } else {
        toast.error(data?.message || "حدث خطأ أثناء الإضافة");
      }
    } catch (error) {
      console.error("خطأ في إضافة المنتج المقترح", error);
      toast.error("حدث خطأ أثناء الإضافة");
    } finally {
      setAddingSuggestedKey(null);
    }
  };

  const deleteEntireCart = async () => {
    try {
      setIsUpdating(true);
      const token = localStorage.getItem("token");
      const response = await fetch(`${base_url}/api/cart`, {
        method: "DELETE",
        headers: { "Authorization": `Bearer ${token}`, "Accept": "application/json" }
      });
      const data = await response.json();
      if (data.status) {
        setCartItems([]);
        toast.success("تم حذف السلة بنجاح");
      } else {
        toast.error("حدث خطأ أثناء حذف السلة");
      }
    } catch (error) {
      console.error("خطأ في حذف السلة", error);
      toast.error("حدث خطأ أثناء حذف السلة");
    } finally {
      setIsUpdating(false);
      closeDeleteCartModal();
    }
  };



  return (
    <>
    <Helmet>
            <title>السلة - يسلمو</title>
          </Helmet>
    
    <div className="min-h-screen bg-gray-50" dir="rtl font-[cairo]">
      <ResponsiveTopNavigation2 />
      <div className="w-full max-w-3xl mx-auto px-3 md:px-4 py-3 pb-28 font-[cairo]">
        {/* Header */}
        <div className="flex items-center justify-between mb-16">

        </div>
        {/* <button
          onClick={openDeleteCartModal}
          className="text-red-500 hover:text-red-600 flex justify-center items-center gap-1"
        >
          <Icon name="Trash2" size={24} />
          <span className="hidden md:inline">حذف السلة بالكامل</span>
        </button> */}
        {cartItems.length > 0 && (
  <button
    onClick={openDeleteCartModal}
    className="text-red-500 hover:text-red-600 flex justify-center items-center gap-1"
  >
    <Icon color="#F93209" name="Trash2" size={22} />
    <span className="hidden md:inline">حذف السلة بالكامل</span>
  </button>
)}
        {/* الكوبونات تظهر فقط عند وجود عناصر في السلة */}
        {cartItems.length > 0 && (
          <CartCopouns fetchCartAgain={fetchCartAgain} />
        )}

        {/* Cart Items */}
        {cartItems.length > 0 ? (
          cartItems?.map((restaurant) => {
            const restaurantSubtotal = calculateRestaurantSubtotal(restaurant);
            return (
              <div
                key={restaurant.id}
                className="mb-3 overflow-hidden rounded-[4px] border border-[#F3ECE7] bg-white font-[cairo] shadow-[0_2px_8px_rgba(17,24,39,0.035)]"
              >
                {/* Restaurant Header */}
                <div dir="ltr" className="flex items-center justify-between border-b border-[#F2EFEB] px-2.5 py-2">
                  <div className="flex items-center gap-2.5">
                    <button
                      onClick={() => toggleRestaurantExpand(restaurant.restaurantId)}
                      className="text-[#6B7280] transition-transform"
                      style={{ transform: restaurant.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
                    >
                      <Icon name="ChevronDown" size={17} />
                    </button>
                    <button
                      onClick={() => openDeleteModal(restaurant.restaurantId, restaurant.storeType, restaurant.restaurantName)}
                      className="text-[#D96C4A] hover:text-[#C75D3E]"
                    >
                      <Icon color="#F93209" name="Trash2" size={16} />
                    </button>
                  </div>

                  <button
                    type="button"
                    onClick={() => handleStoreNavigate(restaurant)}
                    className="flex min-w-0 items-center gap-2 text-right"
                  >
                   
                    <div className="min-w-0">
                      <div className="flex items-center justify-end gap-1.5">
                        <Icon name="ArrowUpLeft" size={13} color="#F93209" />
                        <h2 className="truncate font-[cairo] text-[14px] md:text-[15px] font-bold text-[#1F2937]">
                          {restaurant.restaurantName}
                        </h2>
                      </div>
                    </div>
                    <img
                      src={restaurant.storeLogo}
                      alt={restaurant.restaurantName}
                      className="h-8 w-8 shrink-0 rounded-full border border-[#E9E2DB] object-cover bg-white"
                    />
                  </button>
                </div>

                {/* Items */}
                {restaurant.isExpanded && (
                  <div>
                    {!restaurant.minOrderMet && (
                      <div className="border-b border-[#F2EFEB] bg-white px-2.5 py-2.5">
                        <div className="rounded-[8px] border border-[#F8C99F] bg-[#FFF7F0] px-3 py-1 text-center mb-2.5">
                          <div className="text-[#F93209] text-[12px] md:text-base font-medium flex items-center justify-start gap-1.5">
                            <Icon name="Info" size={16} />
                            <span>
                              باقى {restaurant.minOrderRemaining.toLocaleString()} ل.س للوصول للحد الأدنى
                            </span>
                          </div>
                          <p className="text-[#4B5563] text-[10px] md:text-sm mt-1">
                            أضف منتجات من هذا {restaurant.storeType === "restaurant" ? "المطعم" : "المتجر"} حتى تصل للحد الأدنى ({restaurant.minOrderPrice.toLocaleString()} ل.س) وإلا قم بحذفه
                          </p>
                        </div>

                        {restaurant.suggestedItems.length > 0 && (
  <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
    {restaurant.suggestedItems.slice(0, 12).map((suggestedItem) => {
      const suggestedName = suggestedItem?.name || "منتج";
      const suggestedPrice = Number(
        suggestedItem?.current_price ?? suggestedItem?.price ?? 0
      );
      const suggestedImage = resolveStorageImage(suggestedItem?.image);
      const suggestedKey = `${restaurant.storeType}_${restaurant.restaurantId}_${suggestedItem.id}`;
      const isAdding = addingSuggestedKey === suggestedKey;

      // ✅ تحديد اللون حسب النوع
      const isRestaurant = restaurant.storeType === "restaurant";
      const mainColor = isRestaurant ? "#F93209" : "#00B200";
      const borderColor = isRestaurant ? "#F93209" : "#00B200";

      return (
        <div
          key={suggestedKey}
          className="min-w-[230px] max-w-[230px] bg-white rounded-[6px] border p-2"
          style={{ borderColor }}
        >
          <div className="flex items-center gap-2">
            <img
              src={suggestedImage}
              alt={suggestedName}
              className="w-14 h-14 rounded-[6px] object-cover bg-white"
            />

            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium text-gray-900 line-clamp-2 leading-4">
                {suggestedName}
              </p>

              <div className="mt-1 flex items-center gap-2">
                {/* زر الإضافة */}
                <button
                  onClick={() => addSuggestedItemToCart(restaurant, suggestedItem)}
                  disabled={isAdding}
                  className={`w-6 h-6 rounded-full flex items-center justify-center ${
                    isAdding
                      ? "bg-gray-300 text-white cursor-not-allowed"
                      : "text-white"
                  }`}
                  style={!isAdding ? { backgroundColor: mainColor } : {}}
                >
                  {isAdding ? (
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  ) : (
                    <Icon name="Plus" size={12} />
                  )}
                </button>

                {/* السعر */}
                <p
                  className="text-xs font-bold"
                  style={{ color: mainColor }}
                >
                  {suggestedPrice.toLocaleString()} ل.س / قطعة
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    })}
  </div>
)}
                      </div>
                    )}

                    {restaurant.items.map((item, itemIndex) => (
                      <div key={item.id} className="px-2.5 py-2.5">
                        <div className="flex items-center gap-2.5">
                          <div className="min-w-0 flex-1 text-right">
                            <h3 className="mb-0.5 font-[cairo] text-[14px] md:text-[15px] font-semibold text-[#1F2937]">
                              {item.name}
                            </h3>
                            {item.options && (
                              <p className="mb-1 line-clamp-1 text-[10px] md:text-[11px] text-[#9CA3AF]">
                                {item.options}
                              </p>
                            )}
                            <span className="text-[14px] md:text-[15px] font-bold text-[#F45A2A]">
                              {item.totalPrice.toLocaleString()} ل.س
                            </span>
                          </div>

                          <div dir="ltr" className="flex shrink-0 items-center gap-1.5">
                            <button
                              onClick={() => handleDecreaseOrDelete(restaurant.restaurantId, item)}
                              className={`flex h-8 w-8 items-center justify-center rounded-full bg-[#F5F5F5] leading-none ${
                                item.quantity <= 1 ? "text-[#D96C4A]" : "text-[#1F2937]"
                              }`}
                              aria-label={item.quantity <= 1 ? "حذف العنصر" : "تقليل الكمية"}
                            >
                              {item.quantity <= 1 ? (
                                <Icon name="Trash2" size={15} color="#F93209" />
                              ) : (
                                "−"
                              )}
                            </button>
                            <span className="min-w-[14px] text-center text-[14px] font-bold text-[#F45A2A]">
                              {item.quantity}
                            </span>
                            <button
                              onClick={() => updateQuantity(restaurant.restaurantId, item.id, 1)}
                              className="flex h-8 w-8 items-center justify-center rounded-full bg-[#F5F5F5] text-[16px] leading-none text-[#1F2937]"
                            >
                              +
                            </button>
                          </div>
                        </div>

                        {itemIndex !== restaurant.items.length - 1 && (
                          <div className="mt-2.5 border-t border-[#F2EFEB]" />
                        )}
                      </div>
                    ))}

                    {/* Subtotal */}
                    <div
                      style={{
                        backgroundColor:
                          restaurant.storeType === "restaurant" ? "#F932091A" : "#00B2001A"
                      }}
                      className="flex items-center justify-between rounded-b-[4px] px-2.5 py-2.5"
                    >
                      <span className="text-[#4B5563] text-[13px] md:text-[14px] font-medium">المجموع الفرعي</span>
                      <span className="text-[#1F2937] font-bold text-[13px] md:text-[14px]">{restaurantSubtotal.toLocaleString()} ل.س</span>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div className="flex flex-col items-center justify-center mt-60">
            <img
              src="assets/images/empty-cart.svg" 
              alt="السلة فارغة"
              className="w-48 h-48 md:w-64 md:h-64 mb-4"
            />
            <p className="text-gray-500 font-medium text-md md:text-md">السلة فارغة حالياً</p>
          </div>
        )}

        {/* Summary */}
        {cartItems.length > 0 && summary && (
        <div className="bg-white rounded-[8px] shadow-sm p-3 md:p-4 mb-4 font-[cairo]">
          <div className="flex items-center gap-2 mb-3">
          <img src="/assets/images/llista.svg" className="h-4 w-4" alt="list" />
  <h2 className="font-[cairo] text-base md:text-lg font-bold text-gray-900">
    ملخص الطلب
  </h2>
  
</div>
          <div className="space-y-2 md:space-y-3 text-sm md:text-base">
            <div className="flex items-center justify-between"><span>الفاتورة</span><span>{subtotal.toLocaleString()} ل.س</span></div>
            <div className="flex items-center justify-between"><span>أجور التوصيل</span><span>{deliveryFee.toLocaleString()} ل.س</span></div>
            <div className="flex items-center justify-between"><span>الكوبونات</span><span>{totalDiscount.toLocaleString()} ل.س</span></div>
            <div className="flex items-center justify-between pt-2 border-t font-bold"><span>المجموع الإجمالي</span><span className="text-[#F93209] text-base md:text-lg">{total.toLocaleString()} ل.س</span></div>
          </div>
        </div>
        )}

        {cartItems.length > 0 && (
          <div className="mb-4 rounded-[8px] border border-[#FED7AA] bg-[#FFF7ED] px-3 py-1.5 font-[cairo]">
            <div className=" flex items-center justify-start gap-1 text-[#F93209]">
              <Icon name="Info" size={16} />
              <span className="text-[13px] font-bold md:text-sm">تنبيه:</span>
            </div>
            <p className="text-right text-[11px] font-medium text-black md:text-sm">
              جميع الأسعار معروضة بالعملة الجديدة (بعد حذف صفرين)
            </p>
          </div>
        )}
      </div>

      {/* Sticky Bottom */}
      <div className="fixed bottom-0 left-0 right-0  bg-white border-t shadow-lg px-3 py-3 md:px-4 md:py-4 font-[cairo]">
        <div className="w-full max-w-2xl mx-auto flex items-center justify-between gap-2 md:gap-4">
          <button
            type="button"
            disabled={cartItems.length === 0}
            onClick={() => {
              if (cartItems.length === 0) return;
              navigate("/completeOrder");
            }}
            className="flex-1 rounded-[4px] bg-primary py-3 text-base font-medium text-white transition-colors disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500 md:text-lg"
          >
            أكمل الطلب
          </button>
          <div className="text-right text-sm md:text-base">
            <p className="text-gray-500">المجموع الإجمالي</p>
            <p className="text-gray-900 font-bold text-[16px] md:text-[18px]">{total?.toFixed(0)} ل.س</p>
          </div>
        </div>
      </div>

      <CartDeleteConfirmDialog
        open={confirmDeleteItem.visible}
        title="حذف العنصر من السلة"
        description="سيتم حذف هذا العنصر ولا يمكن التراجع"
        confirmLabel="حذف العنصر"
        onCancel={closeDeleteItemModal}
        onConfirm={deleteCartItem}
      />

      <CartDeleteConfirmDialog
        open={confirmDelete.visible}
        title={`حذف عناصر ${confirmDelete.storeType === "restaurant" ? "المطعم" : "الماركت"} من السلة`}
        description="سيتم حذف كافة العناصر ولا يمكن التراجع"
        confirmLabel="حذف العناصر"
        onCancel={closeDeleteModal}
        onConfirm={deleteRestaurant}
      />

      <CartDeleteConfirmDialog
        open={confirmDeleteCart}
        title="حذف كل عناصر السلة"
        description="سيتم حذف كافة العناصر ولا يمكن التراجع"
        confirmLabel="حذف السلة"
        onCancel={closeDeleteCartModal}
        onConfirm={deleteEntireCart}
      />


      {isUpdating && (
        <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
          <AppSpinner />
        </div>
      )}
    </div>
    {/* <Footer/> */}
    </>
  );
};

export default CartPage;